import { createAction } from 'redux-actions'

export const getMenu = createAction('GET_MENU_STARTED')
export const getMenuSuccess = createAction('GET_MENU_SUCCEED')
export const getMenuFail = createAction('GET_MENU_FAILED')

export const getTimeslots = createAction('GET_TIMESLOTS_STARTED')
export const getTimeslotsSuccess = createAction('GET_TIMESLOTS_SUCCEED')
export const getTimeslotsFail = createAction('GET_TIMESLOTS_FAILED')

export const getUpcomingDays = createAction('GET_UPCOMING_DAYS_STARTED')
export const getUpcomingDaysSuccess = createAction('GET_UPCOMING_DAYS_SUCCEED')
export const getUpcomingDaysFail = createAction('GET_UPCOMING_DAYS_FAILED')

export const changeSelectedCategory = createAction('SELECTED_CATEGORY_CHANGED')



// WEBPACK FOOTER //
// ./src/store/actions/public.js